export const checkWasReminderOpened = (id: string): boolean => !!localStorage.getItem(id)

export const setReminderClosed = (id: string) => localStorage.setItem(id, "true")